export default __webpack_public_path__ + "static/media/profile.c3f94521.png";